import ApolloLinkTimeout from 'apollo-link-timeout';

export default function (timeout) {
  return new ApolloLinkTimeout(timeout);
}
